/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import CategoryTutorialPageComponents from 'components/CategoryTutorial/categoryTutorial.components';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const CategoryTutorialPage = () => {
   return (
      <Fragment>
         <Helmet>
            <title>หมวดหมู่วีดีโอ</title>
         </Helmet>
         <HasAccess
            roles={['Masteradmin']}
            permissions={["category-list"]}
            renderAuthFailed={<ErrorPage404/>}
         >
            <CategoryTutorialPageComponents/>
         </HasAccess>
      </Fragment>
   );
};

export default CategoryTutorialPage;
